import React from "react";
import { Table, Card } from "react-bootstrap";
import { getFormattedDate, decrypt } from "../../util/helpers";

export const PersonalDetails = ({ personalDetails }) => {
  return (
    <div className="container ">
      <Card.Header className="accordian-header">PERSONAL DETAILS</Card.Header>
      <div className="col report text-center">
        <Table striped bordered hover size="sm">
          <tr>
            <td align="left">
              <strong>Name : </strong>
              {`${personalDetails.firstName || ""} ${
                personalDetails.middleName || ""
              } ${personalDetails.lastName || ""}`}
            </td>
            <td align="left">
              <strong>Father Name : </strong>
              {personalDetails.fatherName}
            </td>
            <td align="left">
              <strong>Gender : </strong>
              {personalDetails.gender}
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>Date of birth : </strong>
              {getFormattedDate(personalDetails.birthDate)}
            </td>
            <td align="left">
              <strong>Maritial Status : </strong>
              {personalDetails.maritalStatus}
            </td>
            <td align="left">
              <strong>Anniversary Date : </strong>
              {getFormattedDate(personalDetails.anniversaryDate)}
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>Mobile Number : </strong>
              {personalDetails.contactNumber}
            </td>
            <td align="left">
              <strong>Alternate Mobile Number : </strong>
              {personalDetails.alternateContactNo}
            </td>
            <td align="left">
              <strong>Email : </strong>
              {personalDetails.emailId}
            </td>
          </tr>
          <tr>
            <td align="left">
              <strong>PAN : </strong>
              {decrypt(personalDetails.panCardNo)}
            </td>
            <td align="left">
              <strong>EF UAN : </strong>
              {decrypt(personalDetails.pfUanNo)}
            </td>
            <td align="left">
              <strong>Aadhar : </strong>
              {decrypt(personalDetails.adhaarNumber)}
            </td>
          </tr>
        </Table>
        <h6 className="text-left mb-3">Emergency Contact Details</h6>
        <Table striped bordered hover size="sm">
          <tr>
            <td align="left">
              <strong>Person Name : </strong>
              {personalDetails.emergencyPersonName}
            </td>
            <td align="left">
              <strong>Relationship : </strong>
              {personalDetails.relationWithMe}
            </td>
            <td align="left">
              <strong>Mobile Number : </strong>
              {personalDetails.emergencyContactNo}
            </td>
          </tr>
        </Table>
      </div>
    </div>
  );
};

export default PersonalDetails;
